export { default } from "./isObjectEmpty.mjs";